import { render, staticRenderFns } from "./ProductVariantsUpdate.vue?vue&type=template&id=8ae08d96&scoped=true&"
import script from "./ProductVariantsUpdate.vue?vue&type=script&lang=js&"
export * from "./ProductVariantsUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantsUpdate.vue?vue&type=style&index=0&id=8ae08d96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae08d96",
  null
  
)

export default component.exports